import { appServiceClient } from '@/infrastructure/http/httpClient';

import { IPermissionsResponse } from '../interfaces/permissions';

class PermissionsRepository {
  /** What the signed-in person may do in the active account: the same answer the API enforces. */
  async getPermissions(): Promise<IPermissionsResponse> {
    const response = await appServiceClient.get<IPermissionsResponse | null>('permissions');
    const permissions: Array<unknown> = Array.isArray(response?.permissions) ? response.permissions : [];
    return {
      enforced: response?.enforced === true,
      permissions: permissions.filter((id): id is string => typeof id === 'string'),
    };
  }
}

export const permissionsRepository = new PermissionsRepository();
